import clsx from 'clsx';
import {useState} from 'preact/hooks';
import React, {ElementType} from 'react';
import YouTube from 'react-player/lib/players/YouTube';
import defaultTheme from './video-player.module.pcss';
import {YoutubePoster} from './youtube-poster';

export type Props = {
  /**
   * Element node
   * @default 'div'
   */
  as?: ElementType;
  url: string;
  loaded?: boolean;
  poster?: boolean;
  className?: string;
  theme?: {
    root?: string;
    player?: string;
    poster?: string;
  };
};

export const VideoPlayer = ({
  as: ComponentProp = 'div',
  className,
  url,
  theme = defaultTheme,
  loaded = false,
  poster = false,
  ...rest
}: Props) => {
  const [active, setActive] = useState(loaded);
  const handleClick = () => setActive(true);

  return (
    <ComponentProp className={clsx(theme.root, className)} {...rest}>
      {poster && (
        <YoutubePoster
          url={url}
          clickHandler={handleClick}
          className={theme.poster}
        />
      )}
      {active && (
        <YouTube
          url={url}
          className={theme.player}
          height="100%"
          width="100%"
          playsinline
          config={{
            youtube: {
              playerVars: {
                rel: 0,
              },
            },
          }}
        />
      )}
    </ComponentProp>
  );
};
